import { SortOptionalValue } from 'utils/defaultSort';

export enum PRODUCT_FILTER_ATTRIBUTES {
  _ID = 'id',
  _GROUP_ID = 'customProductGroups',
  _CATEGORY = 'category.keyword',
  _BRAND = 'brand.keyword',
  _SUBTYPE = 'subtype',
  _CLASSIFICATION = 'classification',
  _GENERALS = 'generals',
  _EFFECTS = 'effects',
  _FLAVORS = 'flavors',
  _INGREDIENTS = 'ingredients',
  _AROMAS = 'aromas',
  _TOTAL_THC_PERCENT = 'customTHCPercentageMinValue',
  _TOTAL_TAC_PERCENT = 'customTACPercentageMinValue',
  _TOTAL_CBD_PERCENT = 'customCBDPercentageMinValue',
  _PRICE = 'customMinPrice',
  _SIZE = 'customSize',
  _ON_SALE = 'onSale',
  _IS_HIDE_FROM_MENU = 'isHideFromMenu',
  _IS_ABOVE_THRESHOLD = 'isAboveThreshold',
  _SORT = 'sort',
  _PAGE = 'page',
  _QUERY = 'query',
}

const ProductFilters = [
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._ID,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._CATEGORY,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._BRAND,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._SUBTYPE,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._CLASSIFICATION,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._GENERALS,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._EFFECTS,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._FLAVORS,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._INGREDIENTS,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._AROMAS,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._TOTAL_THC_PERCENT,
    type: 'numeric',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._TOTAL_CBD_PERCENT,
    type: 'numeric',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._TOTAL_TAC_PERCENT,
    type: 'numeric',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._PRICE,
    type: 'numeric',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._SIZE,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._ON_SALE,
    type: 'refinement',
  },
];

export const InitialProductQueryFilters: Record<string, string[]> =
  ProductFilters.filter(
    ({ attribute }) => attribute !== PRODUCT_FILTER_ATTRIBUTES._ON_SALE,
  ).reduce(
    (acc, { attribute, type }) => ({
      ...acc,
      [attribute]: type === 'refinement' ? ([] as string[]) : [':'],
    }),
    {},
  );

export const FilterAttributeNameMapping: Record<string, string> = {
  brand: PRODUCT_FILTER_ATTRIBUTES._BRAND,
  price: PRODUCT_FILTER_ATTRIBUTES._PRICE,
  totalTHCPercent: PRODUCT_FILTER_ATTRIBUTES._TOTAL_THC_PERCENT,
};

export const STRAIN_ORDER = ['Hybrid', 'Indica', 'Sativa', 'CBD', 'I/S', 'S/I'];

export const DEFAULT_PRISMIC_SORT_FILTER: SortOptionalValue = 'Random Order';

export const HEADLESS_TO_OPENSEARCH_MAP: Record<
  SortOptionalValue,
  { sort: string }
> = {
  'Random Order': {
    sort: 'idAsc',
  },
  'Price Low to High': {
    sort: 'customMinPriceAsc',
  },
  'Price High to Low': {
    sort: 'customMinPriceDesc',
  },

  // THC options
  'THC Low to High': {
    sort: 'customTHCPercentageMinValueAsc',
  },
  'THC High to Low': {
    sort: 'customTHCPercentageMinValueDesc',
  },

  // Classification options
  'Classification A–Z': { sort: 'classificationAsc' },
  'Classification Z–A': { sort: 'classificationDesc' },

  // Brand options
  'Brand A–Z': { sort: 'brand.keywordAsc' },
  'Brand Z–A': { sort: 'brand.keywordDesc' },

  // Expiration Date options
  'Expiration Date (Soonest First)': { sort: 'customExpirationDateOldAsc' },
  'Expiration Date (Latest First)': { sort: 'customExpirationDateNewDesc' },

  // Product Creation Date options
  'Product Creation Date (Oldest to Newest)': { sort: 'createdDateAsc' },
  'Product Creation Date (Newest to Oldest)': { sort: 'createdDateDesc' },
};
